/**
 * Single source of truth for the password policy shared across auth/settings
 * forms. The zod schemas validate against PASSWORD_POLICY_REGEX; the reset /
 * change-password forms render `passwordRequirements` as a live checklist.
 */
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

export const PASSWORD_POLICY_MESSAGE =
  'Senha deve conter: 1 maiúscula, 1 minúscula, 1 número e 1 caractere especial (@$!%*?&)';

export interface PasswordRequirement {
  label: string;
  test: (password: string) => boolean;
}

/** Live checklist items rendered by the reset/change password forms. */
export const passwordRequirements: PasswordRequirement[] = [
  { label: 'Mínimo 8 caracteres', test: (password) => password.length >= 8 },
  { label: '1 letra maiúscula', test: (password) => /[A-Z]/.test(password) },
  { label: '1 letra minúscula', test: (password) => /[a-z]/.test(password) },
  { label: '1 número', test: (password) => /\d/.test(password) },
  { label: '1 caractere especial (@$!%*?&)', test: (password) => /[@$!%*?&]/.test(password) },
  { label: 'Apenas caracteres permitidos (letras, números, @$!%*?&)', test: (password) => /^[A-Za-z\d@$!%*?&]*$/.test(password) },
];
